interface AuthPopupOptions {
    width?: number;
    height?: number;
    timeout?: number;
    checkClosed?: boolean;
}

interface AuthResult {
    success: boolean;
    code?: string;
    state?: string;
    error?: string;
    error_description?: string;
}

export class OAuthPopupHandler {
    private popup: Window | null = null;
    private checkInterval: NodeJS.Timeout | null = null;
    private timeoutId: NodeJS.Timeout | null = null;

    async openAuthPopup(
        authUrl: string,
        options: AuthPopupOptions = {}
    ): Promise<AuthResult> {
        const {
            width = 500,
            height = 600,
            timeout = 300000, // 5 minutes
            checkClosed = true
        } = options;

        return new Promise((resolve, reject) => {
            try {
                const left = (window.screen.width / 2) - (width / 2);
                const top = (window.screen.height / 2) - (height / 2);

                const features = [
                    `width=${width}`,
                    `height=${height}`,
                    `left=${left}`,
                    `top=${top}`,
                    'resizable=yes',
                    'scrollbars=yes',
                    'status=yes',
                    'menubar=no',
                    'toolbar=no',
                    'location=no'
                ].join(',');

                // Open popup
                this.popup = window.open(authUrl, 'oauth_popup', features);

                if (!this.popup) {
                    reject(new Error('Popup blocked. Please allow popups for this site.'));
                    return;
                }
                this.popup.focus();

                this.timeoutId = setTimeout(() => {
                    this.cleanup();
                    reject(new Error('Authentication timeout'));
                }, timeout);

            } catch (error) {
                this.cleanup();
                reject(error);
            }
        });
    }

    private cleanup(): void {
        if (this.popup && !this.popup.closed) {
            this.popup.close();
        }
        this.popup = null;

        if (this.checkInterval) {
            clearInterval(this.checkInterval);
            this.checkInterval = null;
        }

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}
